import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import Inicio from './pages/Inicio'
import Tienda from './pages/Tienda'
import Financiamiento from './pages/Financiamiento'
import NuevoCarro from './pages/NuevoCarro'
import Menu from './pages/Menu'
import DetalleCarro from './pages/DetalleCarro'
import Login from './pages/Login'

const App = () => {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Inicio}/>
          <Route exact path="/agregarCarro" component={NuevoCarro}/>
          <Route exact path="/cotizar" component={Financiamiento}/>
          <Route exact path="/detalleCarro/:id" component={DetalleCarro}/>
          <Route exact path="/editarCarro/:id" component={NuevoCarro}/>
          <Route exact path="/inicio" component={Inicio}/>
          <Route exact path="/login" component={Login}/>
          <Route exact path="/menu" component={Menu}/>
          <Route exact path="/tienda" component={Tienda}/>
        </Switch>
      </BrowserRouter>
    )
}

export default App

/* 
   Para instalar React Router
   Ejecutar el comando: npm i react-router-dom --save
   En el archivo package.json eliminar el signo ^ para
   tener una versión estable y no dinámica de router.
   Si el proyecto está abierto, reiniciarlo.
   Luego importar las librerías.

*/